
import { useContext } from "react";
import "./style/jobDesc.css";
import { AppContext } from "../../../contextApi/ContextApi";

export default function JobDesc({job, inx}) {
    const {accent_color} = useContext(AppContext);
    const deployList =(list)=>{
        if (!list) return<p>אין</p>;
        return list?.map((item, inx)=>{
            return <li key={`jobList_${item}_${inx}`} className='descLine_li' >{item}</li>
        })
    }
    const deployDesc=()=>{
        return <div className="desc_sub_div" dir='rtl'>
            <h2 className='descLine_h'>תיאור כללי</h2>
            <p className='descLine_p'>{job.details}</p>
            <h3 className='descLine_h'>דרישות המשרה</h3>
            <ul className='descLine_ul'>{deployList(job?.requirements)}</ul>
            <h2 className='descLine_h'>יתרונות התפקיד</h2>
            <ul className='descLine_ul'>{deployList(job?.benefits)}</ul>
        </div>
    }
    return (
        <div id={`job_description_ID_${inx}`} style={{borderTop:`0.5px solid ${accent_color}`}} className='descDiv'>
            {deployDesc()}
        </div>
    )
}
